import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { OnboardingFacade } from 'app/main/pages/customer-onboard-flow/store/onboarding/onboarding.facade';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-onboarding-how-plan-to-use',
  templateUrl: './onboarding-how-plan-to-use.component.html',
  styleUrls: ['./onboarding-how-plan-to-use.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslocoModule]
})
export class OnboardingHowPlanToUseComponent implements OnInit, OnDestroy {
  @Input() howPlanToUseForm!: FormGroup;
  @Output() planningToUseSelected = new EventEmitter<string>();

  private _unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private _onboardingFacade: OnboardingFacade
  ) { }

  ngOnInit(): void {
    // Subscribe to store to patch form value if it changes from another source
    this._onboardingFacade.howPlanToUsePlanningToUse$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(value => this.howPlanToUseForm.get('planningToUse').patchValue(value, { emitEvent: false }));
  }

  onPlanningToUseSelect(planningToUse: string): void {
    this.howPlanToUseForm.get('planningToUse').setValue(planningToUse);
    this._onboardingFacade.updateHowPlanToUsePlanningToUse(planningToUse);
    this.planningToUseSelected.emit(planningToUse);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}